export function extract_num_id_from_id(id: string) {
	const num_id = id?.split('-').reverse()[0];

	if (num_id) {
		return num_id;
	}
	return '';
}
